<template>
  <div class="search-bar">
    <maple-icon
      v-if="!browerInfo.isMiniProgram"
      name="left_outlined"
      color="#444444"
      size="24"
      @clickIcon="goBack"
    ></maple-icon>
    <form
      class="input-container result-input-container"
      action="javascript:return true"
      @submit.stop.prevent="submitSearch"
    >
      <input
        ref="box"
        type="search"
        :value="keyWord"
        placeholder="搜索参与活动的商品"
        class="js-purchase-box"
        autocomplete="off"
        @keyup.stop.prevent="keyup"
        @input.stop.prevent="input"
      />

      <a
        v-show="insearching"
        class="meicai-icon-container"
        @click="closeSearch"
      >
        <img
          src="@/images/activity_goods/delicon.png"
          alt="del"
          class="del-img"
        />
      </a>
    </form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
export default {
  data() {
    return {
      searchTabIndex: 1,
      insearching: false,
      blurEnvent: false,
      browerInfo: window.matrix
    }
  },
  computed: {
    ...mapState('activityGoods', {
      queryData: state => state.queryData,
      keyWord: state => state.keyword
    })
  },
  methods: {
    ...mapActions('activityGoods', [
      'setActQueryData',
      'clearSkuList',
      'setKeyWord'
    ]),
    setQueryData(name, data) {
      const queryObj = {}
      queryObj[name] = data
      this.setActQueryData(queryObj)
    },
    goBack() {
      this.$back()
    },
    search(keyword) {
      if (keyword === '') {
        this.insearching = false
        // eslint-disable-next-line no-useless-return
        return
      }
    },
    hasFinish: function () {
      if (this.inSearchIng) {
        return
      }
      this.inSearchIng = true

      let val = this.$refs.box.value
      if (!val || val === '') {
        val = this.keyWord.trim()
        document.querySelectorAll('.js-purchase-box')[0].value = val
      }
      this.setQueryData('keyword', val)
      this.setQueryData('page', 0)
      this.clearSkuList()
      this.$emit('activitySkuListOptimize')
      this.blurEnvent = false
      // 调用搜索接口
      setTimeout(function () {
        this.inSearchIng = false
      }, 200)
    },
    // 正式搜索词
    submitSearch() {
      this.$track(this.$trackMap.activityGoods.clickSearch)
      this.inSearchIng = false
      this.hasFinish()
      return false
    },
    // 输入文本框
    keyup(e) {
      this.setKeyWord(e.target.value)
      if (e.keyCode - 0 === 13) {
        this.hasFinish()
        try {
          e.target.blur()
        } catch (e) {
          console.log(e)
        }
      } else {
        this.search(e.target.value)
      }
    },
    input(e) {
      if (e && e.target && e.target.value) {
        this.setKeyWord(e.target.value)
        this.insearching = true
        this.search(e.target.value)
      }
    },
    closeSearch() {
      this.setKeyWord('')
      this.insearching = false
    },
    goSearchBack() {
      this.closeSearch()
      this.goBackPage(this.notCloseWebView)
    }
  }
}
</script>
<style lang="scss" scoped>
.search-bar {
  display: flex;

  box-sizing: border-box;

  height: 44px;
  padding: 7px 0.24rem 7px 0.3rem;

  background-color: #fff;

  flex-flow: row nowrap;

  align-items: center;

  text-align: center;
  .input-container {
    display: flex;

    position: relative;

    margin: 0;
    padding: 0 0.05rem 0 0;

    flex: auto;
    flex-flow: row nowrap;

    align-items: center;

    box-shadow: none;

    &::before {
      display: block;

      position: absolute;
      top: 0;
      right: 0;

      width: 100%;
      height: 30px;

      background-color: #f6f6f6;

      border-radius: 100px;

      content: '';
    }

    .js-purchase-box {
      position: relative;

      width: 100%;
      height: 30px;
      padding: 4px 1.06rem 4px 0.12rem;

      background-color: #f6f6f6;
      border-radius: 100px;
      outline: none;

      box-sizing: border-box;

      -webkit-appearance: none;
      appearance: none;
      box-shadow: none;

      font-size: 0.28rem;
      // line-height: 0.4rem;
      color: #333333;

      &::-webkit-input-placeholder {
        color: #999;
      }

      &:focus {
        outline: none;
      }
    }
    .meicai-icon-container {
      display: flex;

      position: absolute;
      top: 0;
      right: 0.34rem;

      width: 0.6rem;
      height: 0.6rem;

      justify-content: center;
      align-items: center;

      font-size: 0.32rem;
      color: #999999;
      .del-img {
        width: 0.28rem;
        height: 0.28rem;
      }
    }
  }
}
</style>
